import * as React from 'react';
import * as ReactDOM from 'react-dom';

// Shared
import Backdrop from '../backdropModal';

// Portal modal
const modalPortalRoot = document.getElementById('modal-portal-root');

class ModalProps {
  children: any;
  header?: string;
  onClose?: () => void;
}

const Modal = (props: ModalProps) => {
  const [containerEl] = React.useState(() => document.createElement('div'));
  const [hoverClose, setHoverClose] = React.useState(false);

  React.useEffect(() => {
    var modal = document.getElementById('questions-modal-root');
    if (!modal) {
      console.error('missing modal and actor context');
    }
    modalPortalRoot.appendChild(containerEl);

    return () => {
      modalPortalRoot.removeChild(containerEl);
    };
  }, []);

  return ReactDOM.createPortal(
    <div>
      <Backdrop>
        <div className="pop-up-wrapper">
          <div className="pop-up-container" style={{ minHeight: 'unset' }}>
            {props.header && (
              <div className="header-dialog">
                <h3>{props.header}</h3>
              </div>
            )}
            {props.onClose && (
              <i
                onClick={props.onClose}
                className="fa fa-times position-absolute"
                style={{
                  top: 55,
                  right: 55,
                  color: hoverClose ? 'black' : undefined,
                  cursor: hoverClose ? 'pointer' : undefined
                }}
                onMouseEnter={() => setHoverClose(true)}
                onMouseLeave={() => setHoverClose(false)}
              />
            )}
            {props.children}
          </div>
        </div>
      </Backdrop>
    </div>,
    containerEl
  );
};

export default Modal;
